module.exports = __webpack_public_path__ + "assets/img/donate-bg-2.b8d33e64.png";